'use strict';
import popup from 'jquery-popup-overlay';

$(document).ready(function () {
    // Попап после добавления в корзину
    $('#add-to-cart').popup({
        scrolllock: true
    })
})